/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import {
  Form,
  Button,
  Row,
  Col,
  Spin,
  Input,
  Modal,
  message,
  Tabs,
  DatePicker,
  InputNumber,
} from 'antd';
import { CheckCircleOutlined } from '@ant-design/icons';
import { formatReceived } from 'utils/formatValues';
import { onError, onSuccess } from 'utils/handlers';
import Table from 'components/Table';
import FormSubmitControls from 'components/FormSubmitControls';
import ModalDelete from 'components/ModalDelete';
import ModalConfirmation from 'components/ModalConfirmation';
import Select from 'components/Select';
import { getEstadosGlobales } from 'api/catalogos/index';
import {
  getNivelesDeEstudios,
  postNivelDeEstudio,
  deleteNivelDeEstudio,
  patchNivelDeEstudio,
  getNivelDeEstudio,
  autorizarNivelDeEstudio,
} from 'api/catalogos/nivelesDeEstudios';
import { checkToken } from 'api/utils';
import { NOMBRES_PATTERN } from 'utils/patterns';
import {
  ESTATUS_ACTIVO,
  ESTATUS_INACTIVO,
  ESTATUS_AUTORIZADO,
} from 'utils/constants';
import {
  autorizarContratacion,
  getContratacion, getContratacionesVistaoptimizado, patchContratacion, postContratacion,
} from 'api/Contrataciones';
import moment from 'moment/moment';
import { getEmpleados } from 'api/estructuraOrganizacional/empleados';
import { getAdministracionDePlazas } from 'api/catalogos/admnistracionDePlazas';
import { getPlaza } from 'api/catalogos/plazas';
import { getDatoOperacionalesDeEmpleados } from 'api/estructuraOrganizacional/datosOperacionalesDeEmpleados';

export const niveldeestudioPermission = {
  permissionModel: 'niveldeestudio',
  catalogsModels: [],
  tabsModels: [],
};
const { TabPane } = Tabs;

const ContratacionesView = ({ candidatoId }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [estados, setEstados] = useState([]);
  const [selectedData, setSelectedData] = useState({});

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      const [
        _estadosGlobales,
        _contratacion,
      ] = await Promise.all([
        getEstadosGlobales(),
        getContratacionesVistaoptimizado({
          candidato_id: candidatoId,
        }),
      ]);
      if (mounted) {
        setEstados(_estadosGlobales);
        if (_contratacion) {
          form.setFieldsValue(formatReceived(_contratacion[0]));
          setSelectedData(formatReceived(_contratacion[0]));
        }
        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
    // eslint-disable-next-line
  }, [candidatoId]);

  const requiredRule = {
    required: true,
    message: 'El campo es requerido',
  };

  const rules = {
    required: [requiredRule],
    nombre: [
      requiredRule,
      {
        pattern: NOMBRES_PATTERN,
        message: 'Ingrese un nombre válido',
      },
    ],
  };

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        <Tabs defaultActiveKey="1">
          {/* TAB SELECCIÓN (editable con boolean y fecha) */}
          <TabPane tab="Selección" key="1">
            <Form
              layout="vertical"
              form={form}
              scrollToFirstError
              name="seleccion"
              initialValues={{
                seleccionado: selectedData?.seleccionado ?? false,
                fecha_seleccion: selectedData?.fecha_seleccion
                  ? moment(selectedData.fecha_seleccion)
                  : null,
              }}
            >
              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item label="Nombre">
                    <Input value={selectedData?.candidato_numero_y_nombre_completo} disabled />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item label="Fecha de Nacimiento">
                    <Input value={selectedData?.candidato_fecha_nacimiento} disabled />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item label="Edad">
                    <Input value={selectedData?.candidato_edad} disabled />
                  </Form.Item>
                </Col>
                <Col span={16}>
                  <Form.Item label="Nivel de Estudios">
                    <Input value={selectedData?.candidato_nivel_estudios_descripcion} disabled />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item label="Plaza Solicitada">
                    <Input value={selectedData?.vacante_plaza_clave_y_descripcion} disabled />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item label="Puesto Solicitado">
                    <Input value={selectedData?.vacante_puesto_clave_y_descripcion} disabled />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item label="Estado Civil">
                    <Input value={selectedData?.candidato_estado_civil_descripcion} disabled />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item label="Resultado Psicométrico">
                    <Input
                      value={selectedData?.informe_psicometrico_resultado_general_descripcion}
                      disabled
                    />
                  </Form.Item>
                </Col>

                {/* CAMPOS EDITABLES */}
                <Col span={12}>
                  <Form.Item
                    name="seleccionado"
                    label="Seleccionado"
                    rules={[{ required: true, message: 'Selecciona una opción' }]}
                    hasFeedback
                  >
                    <Select trueFalse disabled />
                  </Form.Item>
                </Col>

                <Col span={12}>
                  <Form.Item
                    shouldUpdate={(prev, curr) => prev.seleccionado !== curr.seleccionado}
                    noStyle
                  >
                    {({ getFieldValue }) => {
                      const seleccionado = getFieldValue('seleccionado');
                      return (
                        <Form.Item
                          name="fecha_seleccion"
                          label="Fecha de Selección"
                          rules={
                            seleccionado
                              ? [{ required: true, message: 'Selecciona la fecha' }]
                              : []
                          }
                        >
                          <DatePicker
                            format="DD/MM/YYYY"
                            style={{ width: '100%' }}
                            placeholder={null}
                            disabled
                          />
                        </Form.Item>
                      );
                    }}
                  </Form.Item>
                </Col>

              </Row>

              <Form.Item hidden>
                <Button htmlType="submit" />
              </Form.Item>
            </Form>
          </TabPane>
          {/* TAB CONTRATACIÓN */}
          <TabPane tab="Contratación" key="2">
            <Form
              layout="vertical"
              form={form}
              scrollToFirstError
              name="contratacion"
              initialValues={{
                estados_globales: ESTATUS_ACTIVO,
                es_empleado_del_municipio: false,
              }}
            >
              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item
                    name="contratado"
                    label="Contratado"
                    rules={[{ required: true, message: 'Selecciona una opción' }]}
                    hasFeedback
                  >
                    <Select trueFalse disabled />
                  </Form.Item>
                </Col>

                <Col span={12}>
                  <Form.Item
                    shouldUpdate={(prev, curr) => prev.contratado !== curr.contratado}
                    noStyle
                  >
                    {({ getFieldValue }) => {
                      const contratado = getFieldValue('contratado');
                      return (
                        <Form.Item
                          name="fecha_contratacion"
                          label="Fecha de Contratación"
                          rules={
                            contratado
                              ? [{ required: true, message: 'Selecciona la fecha' }]
                              : []
                          }
                        >
                          <DatePicker
                            format="DD/MM/YYYY"
                            style={{ width: '100%' }}
                            placeholder={null}
                            disabled
                          />
                        </Form.Item>
                      );
                    }}
                  </Form.Item>
                </Col>
                {/* Estatus */}
                <Col xs={24} sm={24} md={24}>
                  <Form.Item
                    name="estados_globales"
                    label="Estatus"
                    rules={rules.required}
                    hasFeedback
                  >
                    <Select
                      labelProp="descripcion"
                      keyProp="id"
                      dataSource={estados}
                      activeInactive={selectedData?.estados_globales === ESTATUS_ACTIVO}
                      disabled
                    />
                  </Form.Item>
                </Col>

                {/* Es empleado del municipio */}
                {/* <Col xs={24} sm={24} md={24}>
                    <Form.Item
                      name="es_empleado_del_municipio"
                      label="¿Es empleado actual del Municipio de Tlajomulco de Zúñiga, Jalisco?"
                      rules={[{ required: true, message: 'Selecciona una opción' }]}
                      hasFeedback
                    >
                      <Select
                        trueFalse
                        disabled={disableFields}
                        onChange={(value) => {
                          setEsEmpleadoMunicipio(value);
                          if (!value) {
                            form.setFieldsValue({
                              numero_empleado_actual: null,
                              area: null,
                              plaza: null,
                              puesto: null,
                              sueldo_mensual: null,
                            });
                          }
                        }}
                      />
                    </Form.Item>
                  </Col> */}

                {/* Número de empleado actual */}
                {/* <Col xs={24} sm={24} md={12}>
                    <Form.Item
                      name="numero_empleado_actual"
                      label="Número de Empleado Actual"
                      rules={
      esEmpleadoMunicipio
        ? [{ required: true, message: 'Captura el número de empleado' }]
        : []
    }
                    >
                      <InputNumber
                        style={{ width: '100%' }}
                        min={1}
                        disabled={!esEmpleadoMunicipio || disableFields}
                        onChange={async (numero) => {
                          if (!numero) {
                            form.setFieldsValue({
                              nombre_empleado: null,
                              area: null,
                              plaza: null,
                              puesto: null,
                              sueldo_mensual: null,
                            });
                            return;
                          }

                          try {
                          //  Buscar empleado por número
                            const empleados = await getEmpleados({ numero_de_empleado: numero });
                            const empleado = empleados?.results?.[0];

                            if (!empleado) {
                              message.warning('No se encontró un empleado con ese número');
                              form.setFieldsValue({
                                nombre_empleado: null,
                                area: null,
                                plaza: null,
                                puesto: null,
                                sueldo_mensual: null,
                              });
                              return;
                            }

                            //  Obtener datos operacionales
                            // eslint-disable-next-line max-len
                            // eslint-disable-next-line max-len
    const [datoOperacional] = await getDatoOperacionalesDeEmpleados({ empleado: empleado.id });

                            let plazaDetalle = null;
                            if (datoOperacional?.plaza) {
                              plazaDetalle = await getPlaza(datoOperacional.plaza);
                            }

                            //  Llenar el formulario
                            form.setFieldsValue({
                              nombre_empleado: empleado.numero_y_nombre_completo || 'N/A',
                              area: plazaDetalle?.directorio_de_area_nombre || 'N/A',
                              plaza: plazaDetalle?.plaza_clave_y_descripcion || 'N/A',
                              puesto: plazaDetalle?.puesto_descripcion || 'N/A',
                              // eslint-disable-next-line max-len
          sueldo_mensual: plazaDetalle?.sueldo_mensual_nominal_asignado || 'N/A',
                            });
                          } catch (err) {
                            message.error('Error al buscar empleado');
                          }
                        }}
                      />
                    </Form.Item>
                  </Col>

                  {esEmpleadoMunicipio && (
                  <>
                    <Row gutter={16}>
                      <Col span={24}>
                        <Form.Item name="nombre_empleado" label="Nombre Completo">
                          <Input disabled />
                        </Form.Item>
                      </Col>
                      <Col span={12}>
                        <Form.Item name="area" label="Área">
                          <Input disabled />
                        </Form.Item>
                      </Col>
                      <Col span={12}>
                        <Form.Item name="plaza" label="Plaza">
                          <Input disabled />
                        </Form.Item>
                      </Col>
                      <Col span={12}>
                        <Form.Item name="puesto" label="Puesto">
                          <Input disabled />
                        </Form.Item>
                      </Col>
                      <Col span={12}>
                        <Form.Item name="sueldo_mensual" label="Sueldo Mensual">
                          <Input disabled />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row gutter={16}>
                      <Col span={24}>
                        <Form.Item
                          name="motivo_por_el_que_el_empleado_participo"
                          // eslint-disable-next-line max-len
label="Motivo por el que el empleado actual participó en el proceso de Reclutamiento y Selección"
                        >
                          <Input.TextArea rows={3} disabled={disableFields} />
                        </Form.Item>
                      </Col>
                    </Row>
                  </>
                  )}
                  {!esEmpleadoMunicipio && (
                  <Col xs={24} sm={24} md={12}>
                    <Form.Item
                      name="numero_empleado"
                      label="Número de Empleado"
                      // rules={[
                      //   { required: true, message: 'Captura el número de empleado' },
                      // ]}

                    >
                      <InputNumber
                        style={{ width: '100%' }}
                        min={1}
                        disabled
                      />
                    </Form.Item>
                  </Col>
                  )} */}

                <Form.Item hidden>
                  <Button htmlType="submit" />
                </Form.Item>
              </Row>
            </Form>
          </TabPane>

        </Tabs>
      </Spin>
    </Row>
  );
};

export default ContratacionesView;
